import React, { useEffect, useState, useContext } from "react";
import DatePicker from "react-datepicker";
import { I18nContext } from "../../i18n";
import "react-datepicker/dist/react-datepicker.css";

const DatePick = (props) => {
  const { translate } = useContext(I18nContext);
  const [startDate, setStartDate] = useState(props.value);

  useEffect(() => {
    setStartDate(props.value);
  }, [props.value]);

  return (
    <div className="alfame-datepicker-wrapper">
      <DatePicker
        dateFormat={["dd.MM.yyyy", "ddMMyyyy"]}
        selected={startDate}
        onChange={(date) => props.handleChange(props.id, date)}
        className="form-control border border-dark"
        placeholderText={translate("trademark_date")}
        name={props.data_cy}
      />
    </div>
  );
};

export default DatePick;
